import React, { useState, useRef } from 'react';
import { navigate, Link as GatsbyLink } from 'gatsby';
import { useI18next } from 'gatsby-plugin-react-i18next';

import Icon from '../../molecules/Icon';
import { color } from '../../atoms/colors';
import { Button, Dropdown } from './styles/index.styled';

const languageMap = {
  en: 'English',
  es: 'Español',
};

const setManualLangCookie = () => {
  document.cookie = 'manualLangSelected=true; path=/; max-age=31536000'; // 1 year
};

const LanguageSwitcher = ({ theme }) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const buttonRef = useRef(null);
  const { languages, originalPath, i18n } = useI18next();

  const handleLanguageClick = (lng, path, e) => {
    e.preventDefault();
    setManualLangCookie();
    navigate(path);
  };

  return (
    <Button
      ref={buttonRef}
      aria-label="Click to change language"
      onClick={() => setDropdownVisible(true)}
      onMouseLeave={() => setDropdownVisible(false)}
    >
      <Icon id="globe-01" width="20px" height="20px" fillColor={theme} />
      {dropdownVisible && (
        <Dropdown
          className="language-dropdown"
          onMouseLeave={() => setDropdownVisible(false)}
        >
          {languages.map(lng => {
            const path = lng === 'en' ? originalPath : `/${lng}${originalPath}`;
            return (
              <li key={lng}>
                <a href={path} onClick={e => handleLanguageClick(lng, path, e)}>
                  {languageMap[lng]}{' '}
                  {i18n.resolvedLanguage === lng && (
                    <Icon
                      id="check"
                      width="16px"
                      height="16px"
                      fillColor={color.blue[700]}
                    />
                  )}
                </a>
              </li>
            );
          })}
        </Dropdown>
      )}
    </Button>
  );
};

export default LanguageSwitcher;
